var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-login"},[_c('button',{staticClass:"p2b c7 google-btn",attrs:{"id":"google-login-button"},on:{"click":_vm.login}},[_c('GoogleIcon'),_vm._v("\n            "+_vm._s(_vm.authType.btnText)+" with Google\n    ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }